import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { Colors } from '../../../models/enums/colors.enum';
import { HttpService } from '../../../services/http.service';
import { ThrowStmt } from '@angular/compiler';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-services-row',
  templateUrl: './services-row.component.html',
  styleUrls: ['./services-row.component.scss']
})
export class ServicesRowComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('scroll', { read: ElementRef }) ds: ElementRef;

  colors = Colors;
  services = [];
  servicesCopy = [];
  scrollContainer;
  scrollContainerScrollWidth;
  scrollContainerWidth;
  scrollLeft;
  pause: boolean = false;
  animating: boolean = false;

  @Input() systemId: string;
  @Input() subSystemId: string;

  subscription: ISubscription;

  constructor(private http: HttpService, private cdref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.subscription = this.http.cardData().subscribe(data => {
      this.services = data;
      if(!this.animating){
        this.servicesCopy = this.services;
      }
    });
    this.servicesCopy = this.services;
  }

  ngAfterViewInit() {
    this.scrollContainer = this.ds.nativeElement.querySelector('.drag-scroll-content');
    this.scrollContainerWidth = this.scrollContainer.getBoundingClientRect().width;
    this.scrollContainerScrollWidth = this.scrollContainer.scrollWidth;
    this.scrollLeft = this.scrollContainer.scrollLeft;

    if (this.scrollContainerScrollWidth > this.scrollContainerWidth){
      const len = this.services.length;
      for (let i = 0; i < len; i++){
        this.servicesCopy.push(this.servicesCopy[i]);
      }
      this.animating = true;
      requestAnimationFrame(() => {
        this.animateScroll(1);
      });
    }

    this.cdref.detectChanges();
  }
  once = false;
  index = 0;
  appendItems() {
    this.servicesCopy.push(this.services[this.index]);
    this.index = (this.index + 1) % this.services.length;
    this.servicesCopy.shift();
    //Set to width of 1 service + 15px of margin
    this.scrollContainer.scrollLeft = 175;
  }

  animateScroll(speed) {
      this.scrollContainer.scrollLeft += speed;
      this.scrollLeft = this.scrollContainer.scrollLeft;
      //When scrolling reaches 2*(width of 1 service + 15px left margin)
      if (this.scrollContainer.scrollLeft >= (350)) {
        this.appendItems();

        this.scrollContainerWidth = this.scrollContainer.getBoundingClientRect().width;
        this.scrollContainerScrollWidth = this.scrollContainer.scrollWidth;
      }
      requestAnimationFrame(() => {
        this.animateScroll(speed);
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/table-column/services-row/services-row.component.ts